import { createGlobalStyle, css } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  ${(props) =>
      props.videoModalOpen &&
      css`
          body {
              overflow: hidden;
          }
      `}
`;

export default GlobalStyles;
